const STORAGE_KEYS = {
  country: 'compopo_country',
  currency: 'compopo_currency',
  sort: 'compopo_sort',
};

const VALID_SORT = ['compopo-sort', 'lowest-first', 'highest-first'];
const DEFAULT_COUNTRY = 'US';
const DEFAULT_CURRENCY = 'USD';
const DEFAULT_SORT = 'compopo-sort';

function readStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    return null;
  }
}

function writeStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    // ignore quota / private mode errors
  }
}

function normalizeCurrency(currency) {
  if (!currency) return DEFAULT_CURRENCY;
  return currency === 'ILS' ? 'NIS' : currency;
}

function migrateFromCookie(cookieGetter) {
  if (!cookieGetter) return null;
  const country = cookieGetter('selectedCountry');
  const currency = cookieGetter('selectedCurrency');
  if (country) {
    writeStorage(STORAGE_KEYS.country, country);
  }
  if (currency) {
    writeStorage(STORAGE_KEYS.currency, normalizeCurrency(currency));
  }
  return { country, currency: normalizeCurrency(currency) };
}

export function initUserPreferences(cookieGetter) {
  const hasLocal = readStorage(STORAGE_KEYS.country) || readStorage(STORAGE_KEYS.currency);
  if (!hasLocal && cookieGetter) {
    migrateFromCookie(cookieGetter);
  }
}

export function getSavedCountry() {
  return readStorage(STORAGE_KEYS.country) || DEFAULT_COUNTRY;
}

export function getSavedCurrency() {
  return normalizeCurrency(readStorage(STORAGE_KEYS.currency) || DEFAULT_CURRENCY);
}

export function getSavedSort() {
  const sort = readStorage(STORAGE_KEYS.sort);
  return VALID_SORT.includes(sort) ? sort : DEFAULT_SORT;
}

export function saveCountry(country) {
  if (!country) return;
  writeStorage(STORAGE_KEYS.country, country);
}

export function saveCurrency(currency) {
  if (!currency) return;
  writeStorage(STORAGE_KEYS.currency, normalizeCurrency(currency));
}

export function saveSort(sort) {
  if (!VALID_SORT.includes(sort)) return;
  writeStorage(STORAGE_KEYS.sort, sort);
}

export function saveShippingPreferences(country, currency) {
  saveCountry(country);
  saveCurrency(currency);
}
